import { useState, useEffect } from 'react';
import shallow from 'zustand/shallow';

import useStore from './index';
import { TPaywallFeature, IFeatureData, SectionEnum } from '../types';
import { PaywallFeatureEnum as PAYWALL, AddOnWidget } from '../constants';

export default function useWidget(activeTab: string) {
  const [isAddonPro, setIsAddonPro] = useState<boolean>(false);

  const { isPro, data, getStatus, addCounter } = useStore(
    (state) => ({
      isPro: state.widget.isPro,
      data: state.widget.data,
      getStatus: state.getStatus,
      addCounter: state.addCounter,
    }),
    shallow,
  );

  useEffect(() => {
    if (!data?.features || !activeTab) return;

    if (activeTab.toUpperCase() === AddOnWidget) {
      const addOnData = data.features.find(
        (item: IFeatureData) => item.feature === PAYWALL.SCREENER,
      );

      setIsAddonPro(addOnData?.is_eligible || false);
    }
  }, [data?.features]);

  const widgetGetStatus = (key: string): void => {
    const KEY = key.toUpperCase();
    const feature: TPaywallFeature = PAYWALL[KEY];
    if (!feature) return;

    if (KEY === AddOnWidget) {
      const features = [PAYWALL.VALUATION, PAYWALL.SCREENER];
      getStatus({ key: SectionEnum.widget, feature: features });
      return;
    }

    getStatus({ key: SectionEnum.widget, feature });
  };

  // post paywall counter
  const widgetAddCounter = (key: string): void => {
    const KEY = key.toUpperCase();
    const feature: TPaywallFeature = PAYWALL[KEY];
    if (!feature) return;

    addCounter({ feature });

    if (KEY === AddOnWidget) {
      addCounter({ feature: PAYWALL.SCREENER });
    }
  };

  useEffect(() => {
    if (!activeTab) return;

    widgetGetStatus(activeTab);
  }, [activeTab]);

  return {
    isPro,
    isAddonPro,
    addCounter: (key: string) => widgetAddCounter(key),
  };
}
